import en from "./locale/en.json";
import th from "./locale/thai.json";

const translations = {
    en: en,
    th: th
  }

export default translations;